'use client';

import { useConfig } from '@/app/contexts/ConfigContext';

import MediaContent from '@/app/(with-metadata)/(main)/media/MediaContent';
import Hero from '../Hero';
import { FITNESS_WORDING_EN } from '@/wording/fitness/FITNESS_WORDING_EN';
import { SERVICE_TYPES } from '@/helpers/enums';

export default function MediaTwoPage() {
  const { config } = useConfig();
  return (
    <main className='max-w-[1920px] mx-auto overflow-hidden'>
      <Hero
        tag={
          // This condition is to prevent a bug in the fitness/yoga/pilates multi-service case where going from /media_2 to a different service type without /media_2 would try to fetch images for media2 before the config was refresh
          config.serviceType === SERVICE_TYPES.FITNESS
            ? FITNESS_WORDING_EN.text_media_2
            : ''
        }
      />
      <MediaContent tag={FITNESS_WORDING_EN.text_media_2} />
    </main>
  );
}
